<template>
  <v-card flat color="grey lighten-3" class="pl-5 pr-4 py-4">
    <!-- Promotion model : Fix store -->
    <v-btn @click="includePartner()">Include all partner</v-btn>
    <v-btn @click="includeNoPartner()">Include all no partner</v-btn>
    <v-btn @click="clearStore()">Clear</v-btn>
    <v-text-field
      prepend-icon="search"
      label="Search store name"
      v-model="search"
    ></v-text-field>
    <v-layout v-for="(info, index) in searchStore" :key="index">
      <!-- <v-flex xs2 md1 class="promo-title" v-if="index < 10">
        <span class="style-title-promo">Store {{ countIndex(info) }} :</span>
      </v-flex>-->
      <v-flex xs9 md10 v-if="index < 10">
        <v-autocomplete
          prepend-icon="storefront"
          :value="info"
          @input="selectStore($event, countIndex(info) - 1)"
          :items="store_list_free"
          return-object
          item-text="store_name_th"
          label="Select store"
          :loading="fetching_store == true ? 'yellow' : false"
          :disabled="fetching_store || isEditPromotion"
          :rules="[rules.store_required, rules.store_already]"
          v-if="form.promotion_order_type == 3"
        ></v-autocomplete>
        <v-autocomplete
          prepend-icon="storefront"
          @input="selectStore($event, countIndex(info) - 1)"
          :value="info"
          :items="store_list"
          return-object
          item-text="store_name_th"
          label="Select store"
          :loading="fetching_store == true ? 'yellow' : false"
          :disabled="fetching_store || isEditPromotion"
          :rules="[rules.store_required, rules.store_already]"
          v-else
        ></v-autocomplete>
      </v-flex>
      <v-flex
        xs2
        md1
        class="text-xs-center pt-4"
        v-if="!isEditPromotion && index < 10"
      >
        <v-icon
          medium
          color="green"
          v-if="countIndex(info) == 1"
          @click="moreStore()"
          >add_box</v-icon
        >
        <v-icon
          medium
          color="red"
          @click="lessStore(countIndex(info) - 1)"
          v-else
          >indeterminate_check_box</v-icon
        >
      </v-flex>
    </v-layout>
    <div class="text-xs-center">Total store: {{ promotion_stores.length }}</div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["promotion_stores", "form", "province"],
  data() {
    return {
      fetching_store: false,
      search: "",
      rules: {
        store_required: (value) =>
          (!!value && value.store_id != 0) || "Required.",
        store_already: (value) =>
          value.store_id != -1 || "Store already to select.",
      },
    };
  },
  computed: {
    ...mapGetters({
      store_list_free: "fetchStoreBack/autocompleteStoreFreedelivery",
      store_list: "fetchStoreBack/autocompleteStore",
      isEditPromotion: "isEditPromotion",
    }),
    searchStore() {
      if (this.search == "") {
        return this.promotion_stores;
      } else {
        return this.promotion_stores.filter((val) => {
          if (val.store_id == 0 || val.store_id == -1) {
            return true;
          } else {
            return val.store_name_th.includes(this.search);
          }
        });
      }
    },
  },
  methods: {
    selectStore(value, index) {
      let payload = {
        value,
        index,
      };
      this.$emit("select", payload);
    },
    countIndex(info) {
      return (
        this.promotion_stores.findIndex((val) => {
          return val.store_id == info.store_id;
        }) + 1
      );
    },
    clearStore() {
      this.$emit("clearInclude");
    },
    includePartner() {
      this.$emit("include");
    },
    includeNoPartner() {
      this.$emit("includeNo");
    },
    moreStore() {
      if (
        this.promotion_stores.length > 0 &&
        (this.promotion_stores[0].store_id == 0 ||
          this.promotion_stores[0].store_id == -1)
      )
        return;

      this.promotion_stores.unshift({ store_id: 0 });
    },
    lessStore(index) {
      this.promotion_stores.splice(index, 1);
    },
    // async initialzation() {
    //   this.fetching_store = true;
    //   await this.$store.dispatch("fetchStoreBack/getStoreList");
    //   this.fetching_store = false;
    // },
  },
  created() {
    // this.initialzation();
  },
};
</script>

<style>
</style>
